import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'


function App() {
  const navItems = [
    { name: 'Accueil', href: '#accueil' },
    { name: 'À propos', href: '#apropos' },
    { name: 'Services', href: '#services' },
    { name: 'Formules', href: '#formules' },
    { name: 'Galerie', href: '#galerie' },
    { name: 'Avis', href: '#avis' },
    { name: 'Récompenses', href: '#recompenses' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
    </BrowserRouter>
  )
}

export default App